module.exports = __webpack_public_path__ + "static/media/year-built.70a9c2c5.jpg";